var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTulu3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    className: "cls-1",
    transform: "translate(1432 1079)",
    d: "M0 0h75v75H0z"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Customized_app",
    "data-name": "Customized app",
    transform: "translate(-1432 -1079)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(1450 1091.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M-313.43 2326.7h-30.022a4.8 4.8 0 0 1-4.794-4.794v-51.031a4.8 4.8 0 0 1 4.794-4.794h30.022a4.8 4.8 0 0 1 4.794 4.794v51.031a4.8 4.8 0 0 1-4.794 4.794zm-30.022-58.948a3.126 3.126 0 0 0-3.123 3.123v51.031a3.126 3.126 0 0 0 3.123 3.123h30.022a3.126 3.126 0 0 0 3.123-3.123v-51.031a3.126 3.126 0 0 0-3.123-3.123z",
    transform: "translate(348.247 -2266.081)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1",
    cx: 4.333,
    cy: 4.333,
    transform: "translate(15.473 47.4)",
    r: 4.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M-298.9 2416.969a5.175 5.175 0 0 1-5.169-5.169 5.175 5.175 0 0 1 5.169-5.168 5.175 5.175 0 0 1 5.169 5.168 5.175 5.175 0 0 1-5.169 5.169zm0-8.666a3.5 3.5 0 0 0-3.5 3.5 3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5 3.5 3.5 0 0 0-3.5-3.503z",
    transform: "translate(318.705 -2360.067)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTulu3);
export default __webpack_public_path__ + "static/media/myTulu3.97c25e37fd87554fdfeca449c85b845b.svg";
export { ForwardRef as ReactComponent };